import'string.prototype.startswith';
import {
    CHANGE_NEW_TOBA_PROPERTIES, CHANGE_TOBA_SETTINGS,
    CLEAR_NEW_TOBA,
    LOGOUT, RECEIVE_BAD_RESPONSE_POST_NEW_TOBA, RECEIVE_POST_NEW_TOBA_RESPONSE,
    REQUEST_POST_NEW_TOBA
} from "../actions/index";
import {
    ADD_TOBA_FORM_ATTACHMENT,
    CLOSE_CREATE_REVISION_CONFIRM_MODAL,
    CLOSE_TOBA_REVISION_MODAL, CLOSE_UPDATE_TOBA_CONFIRM_MODAL,
    FAILED_TO_RECEIVE_TOBA_BY_ID,
    GET_TOBA_BY_ID,
    GET_TOBA_REVISION_BY_ID,
    GET_TOBA_REVISION_BY_ID_FAIL,
    GET_TOBA_REVISION_BY_ID_SUCCESS, GET_TOBA_REVISIONS, GET_TOBA_REVISIONS_FAIL,
    GET_TOBA_REVISIONS_SUCCESS,
    OPEN_CREATE_REVISION_CONFIRM_MODAL,
    OPEN_TOBA_REVISION_MODAL,
    OPEN_UPDATE_TOBA_CONFIRM_MODAL,
    POPULATE_TOBA_FORM_FROM_REVISION,
    RECEIVE_TOBA_BY_ID,
    REMOVE_FETCHED_TOBA_ATTACHMENT,
    REMOVE_TOBA_FORM_ATTACHMENT,
    UPDATE_TOBA,
    UPDATE_TOBA_FAIL,
    UPDATE_TOBA_SUCCESS
} from "../actions";
import moment from 'moment'
import _ from 'lodash';
import { TOBA_SHORT_TEXT } from '../helpers/variables';

const defaultState = {
    tobaFormData: {
        tobaBody: '',
        content:'',
        version: '',
        name: '',
        attachments: [],
        selectedSolicitorGroup: '',
        selectedSolicitorGroups: {},
        checkedSolicitorGroupsIds: [],
        fetchedTobaAttachments: [],
        id: '',
        defaultToba: false,
        validFrom: '',
        expiryDate: '',
        initialRevision: '',
        solicitorGroupFilter: ''
    },
    successMsg: '',
    failMsg: '',
    posting: false,
    badResponse: '',
    previousTobas: [],
    openModal:false,
    selectedPreviousToba: {},
    fetchingToba: false,
    changedMadeOnFetchedToba: false,
    updatingToba: false,
    updateTobaFailMessage: '',
    updateTobaSuccessMessage: '',
    fetchingTobaRevision: false,
    fetchingTobaRevisionFailMessage: '',
    confirmRevisionCreateModalOpen: false,
    confirmTobaUpdateModalOpen: false,
    fetchingTobaRevisions: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case OPEN_UPDATE_TOBA_CONFIRM_MODAL:
            return {
                ...state,
                confirmTobaUpdateModalOpen: true
            };
        case CLOSE_UPDATE_TOBA_CONFIRM_MODAL:
            return {
                ...state,
                confirmTobaUpdateModalOpen: false
            };
        case OPEN_CREATE_REVISION_CONFIRM_MODAL:
            return {
                ...state,
                confirmRevisionCreateModalOpen: true
            };
        case CLOSE_CREATE_REVISION_CONFIRM_MODAL:
            return {
                ...state,
                confirmRevisionCreateModalOpen: false
            };
        case GET_TOBA_REVISION_BY_ID:
            return {
                ...state,
                fetchingTobaRevision: true
            };
        case GET_TOBA_REVISION_BY_ID_SUCCESS:
            if(!action.payload.body) return {...state, fetchingTobaRevision: false};
            return {
                ...state,
                fetchingTobaRevision: false,
                selectedPreviousToba: action.payload.body
            };
        case GET_TOBA_REVISION_BY_ID_FAIL:
            return {
                ...state,
                fetchingTobaRevisionFailMessage: `Failed to fetch ${TOBA_SHORT_TEXT} revision`,
                fetchingTobaRevision: false
            };
        case UPDATE_TOBA:
            return {
                ...state,
                updatingToba: true,
                updateTobaFailMessage: defaultState.updateTobaFailMessage,
                updateTobaSuccessMessage: defaultState.updateTobaSuccessMessage,
                successMsg: defaultState.successMsg,
                failMsg: defaultState.failMsg,
                badResponse: defaultState.badResponse
            };
        case UPDATE_TOBA_SUCCESS:
            return {
                ...state,
                updatingToba: false,
                updateTobaSuccessMessage: `${TOBA_SHORT_TEXT} was updated successfully.`
            };
        case UPDATE_TOBA_FAIL:
            let mS ;
            try {
                mS = action.payload.response.body.message;
            } catch (e) {
                mS = `Failed to update ${TOBA_SHORT_TEXT}`
            }
            return {
                ...state,
                updatingToba: false,
                updateTobaFailMessage: mS
            };
        case OPEN_TOBA_REVISION_MODAL:
            return {
                ...state,
                openModal: true
            };
        case CLOSE_TOBA_REVISION_MODAL:
            return {
                ...state,
                openModal: false,
                selectedPreviousToba: defaultState.selectedPreviousToba
            };
        case POPULATE_TOBA_FORM_FROM_REVISION:
            return {
                ...state,
                openModal: false,
                selectedPreviousToba: defaultState.selectedPreviousToba
            };
        case GET_TOBA_REVISIONS:
            return {
                ...state,
                fetchingTobaRevisions: true
            };
        case GET_TOBA_REVISIONS_SUCCESS:
            return {
                ...state,
                previousTobas: action.payload.body || [],
                fetchingTobaRevisions: false,
                failMsg: defaultState.failMsg
            };
        case GET_TOBA_REVISIONS_FAIL:
            let fetchTobaRevisionsFailMessage = '';
            try {
                fetchTobaRevisionsFailMessage = action.payload.response.body.message
            } catch (e) {
                fetchTobaRevisionsFailMessage = `Failed to fetch ${TOBA_SHORT_TEXT} revisions.`;
            }
            return {
                ...state,
                fetchingTobaRevisions: false,
                failMsg: fetchTobaRevisionsFailMessage
            };
        case REMOVE_FETCHED_TOBA_ATTACHMENT:
            let nAttachments = [...state.tobaFormData.fetchedTobaAttachments];
            if (action.payload > -1) {
                nAttachments.splice(action.payload, 1);
            }
            return {
                ...state,
                tobaFormData: {
                    ...state.tobaFormData,
                    fetchedTobaAttachments: nAttachments
                },
                changedMadeOnFetchedToba: true
            };
        case GET_TOBA_BY_ID:
            return {
                ...state,
                fetchingToba: true
            };
        case RECEIVE_TOBA_BY_ID:
            if(!action.payload) return defaultState;
            return {
                ...state,
                tobaFormData: {
                    ...state.tobaFormData,
                    tobaBody: action.payload.body.content,
                    selectedSolicitorGroup: action.payload.body.solicitorGroupId,
                    selectedSolicitorGroups: _.mapValues(_.keyBy(action.payload.body.solicitorGroupDtos, 'id'), i => i),
                    name: action.payload.body.name,
                    version: action.payload.body.version,
                    fetchedTobaAttachments: action.payload.body.tobaAttachmentDtos || [],
                    id: action.payload.body.id,
                    defaultToba: (action.payload.body.solicitorGroupDtos || []).length === 0,
                    validFrom: action.payload.body.validFrom?moment(action.payload.body.validFrom).format('DD/MM/YYYY'):'',
                    expiryDate: action.payload.body.validUntil?moment(action.payload.body.validUntil).format('DD/MM/YYYY'):'',
                    initialRevision: action.payload.body.initialRevision?action.payload.body.initialRevision:'',
                    solicitorGroupFilter: defaultState.solicitorGroupFilter
                },
                fetchingToba: false,
                changedMadeOnFetchedToba: false
            };
        case FAILED_TO_RECEIVE_TOBA_BY_ID:
            return {
                ...state,
                fetchingToba: false
            };
        case ADD_TOBA_FORM_ATTACHMENT:
            return {
                ...state,
                tobaFormData: {
                    ...state.tobaFormData,
                    attachments: [
                        ...state.tobaFormData.attachments,
                        action.payload
                    ]
                },
                changedMadeOnFetchedToba: true
            };
        case REMOVE_TOBA_FORM_ATTACHMENT:
            let newAttachments = [...state.tobaFormData.attachments];
            if (action.payload > -1) {
                newAttachments.splice(action.payload, 1);
            }
            return {
                ...state,
                tobaFormData: {
                    ...state.tobaFormData,
                    attachments: newAttachments
                },
                changedMadeOnFetchedToba: true
            };
        case CHANGE_TOBA_SETTINGS:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        case CHANGE_NEW_TOBA_PROPERTIES:
            return {
                ...state,
                tobaFormData: {
                    ...state.tobaFormData,
                    [action.payload.key]:action.payload.value
                },
                // clear all response messages so stale errors/successes don't persist while the user edits
                successMsg: defaultState.successMsg,
                badResponse: defaultState.badResponse,
                failMsg: defaultState.failMsg,
                updateTobaFailMessage: defaultState.updateTobaFailMessage,
                updateTobaSuccessMessage: defaultState.updateTobaSuccessMessage,
                changedMadeOnFetchedToba: true
            };
        case REQUEST_POST_NEW_TOBA:
            return {
                ...state,
                posting: true,
                // clear previous response state so the HOC can detect a fresh successMsg on completion
                successMsg: defaultState.successMsg,
                failMsg: defaultState.failMsg,
                badResponse: defaultState.badResponse,
                updateTobaFailMessage: defaultState.updateTobaFailMessage,
                updateTobaSuccessMessage: defaultState.updateTobaSuccessMessage,
            };
        case RECEIVE_POST_NEW_TOBA_RESPONSE:
            return {
                ...state,
                posting: false,
                successMsg: state.tobaFormData.id?`${TOBA_SHORT_TEXT} was edited successfully`:`New ${TOBA_SHORT_TEXT} was created successfully.`,
                tobaFormData: defaultState.tobaFormData,
                changedMadeOnFetchedToba: false
            };
        case CLEAR_NEW_TOBA:
            return {
                ...defaultState
            };
        case RECEIVE_BAD_RESPONSE_POST_NEW_TOBA:
            let errorMsg = '';
            try {
                errorMsg = action.payload.response.body.message;
            }
            catch(e) {
                errorMsg = `Failed to create new ${TOBA_SHORT_TEXT}.`;
            }
            return {
                ...state,
                posting: false,
                badResponse: errorMsg
            };
        case LOGOUT:
            return {
                ...defaultState
            };
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                tobaFormData: defaultState.tobaFormData,
                successMsg: defaultState.successMsg,
                failMsg: defaultState.failMsg,
                badResponse: defaultState.badResponse,
                changedMadeOnFetchedToba: defaultState.changedMadeOnFetchedToba,
                previousTobas: defaultState.previousTobas,
                updateTobaFailMessage: defaultState.updateTobaFailMessage,
                updateTobaSuccessMessage: defaultState.updateTobaSuccessMessage,
                fetchingTobaRevisionFailMessage: defaultState.fetchingTobaRevisionFailMessage
            };
        default :
            return state
    }
}